import { AtomsView } from "ui";

interface Props {
  children: React.ReactNode;
}

export default function Card({ children }: Props) {
  return (
    <AtomsView className="rounded-md bg-background-0 shadow-[0px_3px_10px_0px_rgba(38,38,38,0.20)] p-4 w-80 gap-4">
      {children}
    </AtomsView>
  );
}
